module.exports = __webpack_public_path__ + "assets/static/png/zsu-soldier.5667afd7348a0a531049de8cd7d94ed6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/images/zsu-soldier.png
 ** module id = 528
 ** module chunks = 1
 **/